import React, { Component } from 'react';
import { Button, Container } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage } from "react-intl";
import ContentLoader from "../../components/ContentLoader";
import { withRouter } from 'react-router-dom';
import MetaTags from '../../components/SEO/MetaTags'
import { handlePublicRequestError, Request } from '../../helpers/request'
import { colorOptions } from '../../helpers/select'
import { addLocalePrefix } from '../../components/Routes/LocaleLink'

class CaseStudy extends Component {
    state = {
        caseStudies: [],
        selectedCaseStudy: null,
        loading: false
    };

    componentDidMount() {
        Request.get('study_cases')
            .then((caseStudies) => {
                this.setState({ caseStudies });
            })
            .catch(handlePublicRequestError);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const caseStudySlug = this.props.match?.params?.slug
        if (this.state.caseStudies.length) {
            if (!caseStudySlug) {
                const [caseStudy] = this.state.caseStudies
                this.props.history.replace(addLocalePrefix(`/case-study/${caseStudy.slug}`))
            } else if (this.state.selectedCaseStudy?.slug !== caseStudySlug) {
                const selectedCaseStudy = this.state.caseStudies.find(c => c.slug === caseStudySlug)
                // TODO remove after un randomize
                if (!selectedCaseStudy) {
                    this.props.history.push(addLocalePrefix(`/case-study`))
                    return
                }
                this.setState({ selectedCaseStudy })
            }
        }
    }

    handleCompanySection(id) {
        Request.get('study_cases/' + id)
            .then((study_case) => this.setState({ study_case }, () => window.scrollTo({
                top: 0,
                behavior: 'smooth'
            }, this.props.history.push(addLocalePrefix(`/case-study/${study_case.slug}`)))))
            .catch(handlePublicRequestError);

    }

    downloadFile() {
        window.open('/api/study_cases/' + this.state.selectedCaseStudy.id + '/download');
    }

    acronymize = (author) => {
        let names = author.split(' ');
        let firstname = names[0];
        let lastname = names[names.length - 1].substring(0, 1).toUpperCase();

        return firstname + ' ' + lastname + '.';
    };

    render() {
        if (!this.state.caseStudies?.length) {
            return null
        }

        return (
            <div className="case-study">

                <MetaTags page="case_study" />

                <section className="section-study">
                    <Container>
                        <div className="study-head">
                            <h1 className="line-heading">
                                <FormattedMessage
                                    id="portfolio.case_study.title"
                                    defaultMessage="Études de cas"
                                />
                            </h1>
                            <h2 className="subtitle">
                                <FormattedMessage
                                    id="portfolio.case_study.subtitle"
                                    defaultMessage="Nos clients prennent le relais pour témoigner de leur expérience avec Urban Linker."
                                />
                            </h2>
                        </div>

                        {this.renderCompanyBlock()}

                        {this.renderCaseStudies()}

                    </Container>
                </section>
            </div>
        )
    }

    renderCompanyBlock() {

        const { selectedCaseStudy } = this.state;

        if (!selectedCaseStudy)
            return <ContentLoader />;

        let attachment = selectedCaseStudy.attachments ? selectedCaseStudy.attachments.find((attachment) => attachment.type === 'study_company') : null;
        let company_url = !/^(?:f|ht)tps?\:\/\//.test(selectedCaseStudy.company_url) ? "https://" + selectedCaseStudy.company_url : selectedCaseStudy.company_url;

        return (
            <div className="company-block">
                <div className="cmpny-img">
                    <img src={attachment ? attachment.url : ''} alt={selectedCaseStudy.company_name} />
                </div>
                <div className="cmpny-info">

                    {this.renderDownloadButton()}

                    <h3>{selectedCaseStudy.company_name}</h3>
                    <a href={company_url} className="btn-link" target={"_blank"}>
                        <FormattedMessage
                            id="portfolio.case_study.see_website"
                            defaultMessage="Voir le site"
                        />
                        <FontAwesomeIcon icon={faArrowRight} className={'icon'} />
                    </a>
                    <div className={'pt-3 study-case'}>
                        {selectedCaseStudy.content}
                    </div>
                    <blockquote className="quote">
                        <span className='d-flex'>
                            {selectedCaseStudy.testimony_content}
                        </span>
                        <span className="text-sign position-absolute">
                            <span>{this.acronymize(selectedCaseStudy.testimony_author)}</span>
                        </span>
                    </blockquote>
                </div>
            </div>
        )
    }

    renderDownloadButton() {

        const { selectedCaseStudy } = this.state;

        let attachment = selectedCaseStudy?.attachments?.find((attachment) => attachment.type === 'study_link') ?? null;

        if (!attachment)
            return null;

        return (
            <div className="btn-wrap">
                <Button
                    className="btn btn-warning"
                    onClick={() => this.downloadFile(attachment)}
                >
                    <FormattedMessage
                        id="portfolio.case_study.download"
                        defaultMessage="Télécharger l'étude"
                    />
                </Button>
            </div>
        )
    }

    renderCaseStudies() {

        const { caseStudies } = this.state;

        if (!caseStudies)
            return <ContentLoader />;

        return (
            <div className="clients-block">
                <ul>
                    {
                        caseStudies.map((selectedCaseStudy, key) => {
                            return this.renderCaseStudy(key, selectedCaseStudy);
                        })
                    }
                </ul>
            </div>
        )
    }

    renderCaseStudy(key, selectedCaseStudy) {

        const color = colorOptions[Math.floor(Math.random() * colorOptions.length)];
        let attachment = selectedCaseStudy.attachments ? selectedCaseStudy.attachments.find((attachment) => attachment.type === 'study_company') : null;

        return (
            <li
                className={"brand-" + color.value + " brand" + (key + 1)}
                key={key}
                onClick={() => this.handleCompanySection(selectedCaseStudy.id)}

            >
                <img src={attachment?.url} alt={selectedCaseStudy.company_name} />
            </li>
        )
    }
}

export default withRouter(CaseStudy);
